import { SelectOption } from '../components/common/SearchableSelect/SearchableSelect';

export interface CallingCode extends SelectOption {
  /** ISO 3166-1 alpha-2 country code for flag display */
  iso: string;
}

export const CALLING_CODES: CallingCode[] = [
  { value: '55', label: 'Brasil (+55)', iso: 'BR' },
  { value: '93', label: 'Afeganistão (+93)', iso: 'AF' },
  { value: '27', label: 'África do Sul (+27)', iso: 'ZA' },
  { value: '355', label: 'Albânia (+355)', iso: 'AL' },
  { value: '49', label: 'Alemanha (+49)', iso: 'DE' },
  { value: '376', label: 'Andorra (+376)', iso: 'AD' },
  { value: '244', label: 'Angola (+244)', iso: 'AO' },
  { value: '1268', label: 'Antígua e Barbuda (+1268)', iso: 'AG' },
  { value: '966', label: 'Arábia Saudita (+966)', iso: 'SA' },
  { value: '213', label: 'Argélia (+213)', iso: 'DZ' },
  { value: '54', label: 'Argentina (+54)', iso: 'AR' },
  { value: '374', label: 'Armênia (+374)', iso: 'AM' },
  { value: '61', label: 'Austrália (+61)', iso: 'AU' },
  { value: '43', label: 'Áustria (+43)', iso: 'AT' },
  { value: '994', label: 'Azerbaijão (+994)', iso: 'AZ' },
  { value: '1242', label: 'Bahamas (+1242)', iso: 'BS' },
  { value: '880', label: 'Bangladesh (+880)', iso: 'BD' },
  { value: '1246', label: 'Barbados (+1246)', iso: 'BB' },
  { value: '973', label: 'Barein (+973)', iso: 'BH' },
  { value: '32', label: 'Bélgica (+32)', iso: 'BE' },
  { value: '501', label: 'Belize (+501)', iso: 'BZ' },
  { value: '229', label: 'Benim (+229)', iso: 'BJ' },
  { value: '375', label: 'Bielorrússia (+375)', iso: 'BY' },
  { value: '591', label: 'Bolívia (+591)', iso: 'BO' },
  { value: '387', label: 'Bósnia e Herzegovina (+387)', iso: 'BA' },
  { value: '267', label: 'Botsuana (+267)', iso: 'BW' },
  { value: '673', label: 'Brunei (+673)', iso: 'BN' },
  { value: '359', label: 'Bulgária (+359)', iso: 'BG' },
  { value: '226', label: 'Burquina Faso (+226)', iso: 'BF' },
  { value: '257', label: 'Burundi (+257)', iso: 'BI' },
  { value: '975', label: 'Butão (+975)', iso: 'BT' },
  { value: '238', label: 'Cabo Verde (+238)', iso: 'CV' },
  { value: '237', label: 'Camarões (+237)', iso: 'CM' },
  { value: '855', label: 'Camboja (+855)', iso: 'KH' },
  { value: '1_CA', label: 'Canadá (+1)', iso: 'CA' },
  { value: '974', label: 'Catar (+974)', iso: 'QA' },
  { value: '7_KZ', label: 'Cazaquistão (+7)', iso: 'KZ' },
  { value: '235', label: 'Chade (+235)', iso: 'TD' },
  { value: '56', label: 'Chile (+56)', iso: 'CL' },
  { value: '86', label: 'China (+86)', iso: 'CN' },
  { value: '357', label: 'Chipre (+357)', iso: 'CY' },
  { value: '57', label: 'Colômbia (+57)', iso: 'CO' },
  { value: '269', label: 'Comores (+269)', iso: 'KM' },
  { value: '242', label: 'Congo (+242)', iso: 'CG' },
  { value: '850', label: 'Coreia do Norte (+850)', iso: 'KP' },
  { value: '82', label: 'Coreia do Sul (+82)', iso: 'KR' },
  { value: '225', label: 'Costa do Marfim (+225)', iso: 'CI' },
  { value: '506', label: 'Costa Rica (+506)', iso: 'CR' },
  { value: '385', label: 'Croácia (+385)', iso: 'HR' },
  { value: '53', label: 'Cuba (+53)', iso: 'CU' },
  { value: '5999', label: 'Curaçao (+5999)', iso: 'CW' },
  { value: '45', label: 'Dinamarca (+45)', iso: 'DK' },
  { value: '253', label: 'Djibuti (+253)', iso: 'DJ' },
  { value: '1767', label: 'Dominica (+1767)', iso: 'DM' },
  { value: '20', label: 'Egito (+20)', iso: 'EG' },
  { value: '503', label: 'El Salvador (+503)', iso: 'SV' },
  { value: '971', label: 'Emirados Árabes Unidos (+971)', iso: 'AE' },
  { value: '593', label: 'Equador (+593)', iso: 'EC' },
  { value: '291', label: 'Eritreia (+291)', iso: 'ER' },
  { value: '421', label: 'Eslováquia (+421)', iso: 'SK' },
  { value: '386', label: 'Eslovênia (+386)', iso: 'SI' },
  { value: '34', label: 'Espanha (+34)', iso: 'ES' },
  { value: '372', label: 'Estônia (+372)', iso: 'EE' },
  { value: '1_US', label: 'Estados Unidos (+1)', iso: 'US' },
  { value: '268', label: 'Esuatíni (+268)', iso: 'SZ' },
  { value: '251', label: 'Etiópia (+251)', iso: 'ET' },
  { value: '679', label: 'Fiji (+679)', iso: 'FJ' },
  { value: '63', label: 'Filipinas (+63)', iso: 'PH' },
  { value: '358', label: 'Finlândia (+358)', iso: 'FI' },
  { value: '33', label: 'França (+33)', iso: 'FR' },
  { value: '241', label: 'Gabão (+241)', iso: 'GA' },
  { value: '220', label: 'Gâmbia (+220)', iso: 'GM' },
  { value: '233', label: 'Gana (+233)', iso: 'GH' },
  { value: '995', label: 'Geórgia (+995)', iso: 'GE' },
  { value: '1473', label: 'Granada (+1473)', iso: 'GD' },
  { value: '30', label: 'Grécia (+30)', iso: 'GR' },
  { value: '502', label: 'Guatemala (+502)', iso: 'GT' },
  { value: '592', label: 'Guiana (+592)', iso: 'GY' },
  { value: '224', label: 'Guiné (+224)', iso: 'GN' },
  { value: '240', label: 'Guiné Equatorial (+240)', iso: 'GQ' },
  { value: '245', label: 'Guiné-Bissau (+245)', iso: 'GW' },
  { value: '509', label: 'Haiti (+509)', iso: 'HT' },
  { value: '31', label: 'Holanda (+31)', iso: 'NL' },
  { value: '504', label: 'Honduras (+504)', iso: 'HN' },
  { value: '36', label: 'Hungria (+36)', iso: 'HU' },
  { value: '967', label: 'Iêmen (+967)', iso: 'YE' },
  { value: '91', label: 'Índia (+91)', iso: 'IN' },
  { value: '62', label: 'Indonésia (+62)', iso: 'ID' },
  { value: '964', label: 'Iraque (+964)', iso: 'IQ' },
  { value: '98', label: 'Irã (+98)', iso: 'IR' },
  { value: '353', label: 'Irlanda (+353)', iso: 'IE' },
  { value: '354', label: 'Islândia (+354)', iso: 'IS' },
  { value: '972', label: 'Israel (+972)', iso: 'IL' },
  { value: '39', label: 'Itália (+39)', iso: 'IT' },
  { value: '1876', label: 'Jamaica (+1876)', iso: 'JM' },
  { value: '81', label: 'Japão (+81)', iso: 'JP' },
  { value: '962', label: 'Jordânia (+962)', iso: 'JO' },
  { value: '965', label: 'Kuwait (+965)', iso: 'KW' },
  { value: '856', label: 'Laos (+856)', iso: 'LA' },
  { value: '266', label: 'Lesoto (+266)', iso: 'LS' },
  { value: '371', label: 'Letônia (+371)', iso: 'LV' },
  { value: '961', label: 'Líbano (+961)', iso: 'LB' },
  { value: '231', label: 'Libéria (+231)', iso: 'LR' },
  { value: '218', label: 'Líbia (+218)', iso: 'LY' },
  { value: '423', label: 'Liechtenstein (+423)', iso: 'LI' },
  { value: '370', label: 'Lituânia (+370)', iso: 'LT' },
  { value: '352', label: 'Luxemburgo (+352)', iso: 'LU' },
  { value: '389', label: 'Macedônia do Norte (+389)', iso: 'MK' },
  { value: '261', label: 'Madagascar (+261)', iso: 'MG' },
  { value: '60', label: 'Malásia (+60)', iso: 'MY' },
  { value: '265', label: 'Maláui (+265)', iso: 'MW' },
  { value: '960', label: 'Maldivas (+960)', iso: 'MV' },
  { value: '223', label: 'Mali (+223)', iso: 'ML' },
  { value: '356', label: 'Malta (+356)', iso: 'MT' },
  { value: '212', label: 'Marrocos (+212)', iso: 'MA' },
  { value: '230', label: 'Maurício (+230)', iso: 'MU' },
  { value: '222', label: 'Mauritânia (+222)', iso: 'MR' },
  { value: '52', label: 'México (+52)', iso: 'MX' },
  { value: '95', label: 'Mianmar (+95)', iso: 'MM' },
  { value: '691', label: 'Micronésia (+691)', iso: 'FM' },
  { value: '258', label: 'Moçambique (+258)', iso: 'MZ' },
  { value: '373', label: 'Moldávia (+373)', iso: 'MD' },
  { value: '377', label: 'Mônaco (+377)', iso: 'MC' },
  { value: '976', label: 'Mongólia (+976)', iso: 'MN' },
  { value: '382', label: 'Montenegro (+382)', iso: 'ME' },
  { value: '264', label: 'Namíbia (+264)', iso: 'NA' },
  { value: '674', label: 'Nauru (+674)', iso: 'NR' },
  { value: '977', label: 'Nepal (+977)', iso: 'NP' },
  { value: '505', label: 'Nicarágua (+505)', iso: 'NI' },
  { value: '227', label: 'Níger (+227)', iso: 'NE' },
  { value: '234', label: 'Nigéria (+234)', iso: 'NG' },
  { value: '47', label: 'Noruega (+47)', iso: 'NO' },
  { value: '64', label: 'Nova Zelândia (+64)', iso: 'NZ' },
  { value: '968', label: 'Omã (+968)', iso: 'OM' },
  { value: '680', label: 'Palau (+680)', iso: 'PW' },
  { value: '970', label: 'Palestina (+970)', iso: 'PS' },
  { value: '507', label: 'Panamá (+507)', iso: 'PA' },
  { value: '675', label: 'Papua-Nova Guiné (+675)', iso: 'PG' },
  { value: '92', label: 'Paquistão (+92)', iso: 'PK' },
  { value: '595', label: 'Paraguai (+595)', iso: 'PY' },
  { value: '51', label: 'Peru (+51)', iso: 'PE' },
  { value: '48', label: 'Polônia (+48)', iso: 'PL' },
  { value: '351', label: 'Portugal (+351)', iso: 'PT' },
  { value: '254', label: 'Quênia (+254)', iso: 'KE' },
  { value: '996', label: 'Quirguistão (+996)', iso: 'KG' },
  { value: '686', label: 'Quiribáti (+686)', iso: 'KI' },
  { value: '44', label: 'Reino Unido (+44)', iso: 'GB' },
  { value: '236', label: 'República Centro-Africana (+236)', iso: 'CF' },
  { value: '243', label: 'Rep. Dem. do Congo (+243)', iso: 'CD' },
  { value: '1809', label: 'República Dominicana (+1809)', iso: 'DO' },
  { value: '420', label: 'República Tcheca (+420)', iso: 'CZ' },
  { value: '40', label: 'Romênia (+40)', iso: 'RO' },
  { value: '7_RU', label: 'Rússia (+7)', iso: 'RU' },
  { value: '250', label: 'Ruanda (+250)', iso: 'RW' },
  { value: '685', label: 'Samoa (+685)', iso: 'WS' },
  { value: '378', label: 'San Marino (+378)', iso: 'SM' },
  { value: '1758', label: 'Santa Lúcia (+1758)', iso: 'LC' },
  { value: '1869', label: 'São Cristóvão e Névis (+1869)', iso: 'KN' },
  { value: '239', label: 'São Tomé e Príncipe (+239)', iso: 'ST' },
  { value: '1784', label: 'São Vicente e Granadinas (+1784)', iso: 'VC' },
  { value: '248', label: 'Seicheles (+248)', iso: 'SC' },
  { value: '221', label: 'Senegal (+221)', iso: 'SN' },
  { value: '232', label: 'Serra Leoa (+232)', iso: 'SL' },
  { value: '381', label: 'Sérvia (+381)', iso: 'RS' },
  { value: '65', label: 'Singapura (+65)', iso: 'SG' },
  { value: '963', label: 'Síria (+963)', iso: 'SY' },
  { value: '252', label: 'Somália (+252)', iso: 'SO' },
  { value: '94', label: 'Sri Lanka (+94)', iso: 'LK' },
  { value: '249', label: 'Sudão (+249)', iso: 'SD' },
  { value: '211', label: 'Sudão do Sul (+211)', iso: 'SS' },
  { value: '46', label: 'Suécia (+46)', iso: 'SE' },
  { value: '41', label: 'Suíça (+41)', iso: 'CH' },
  { value: '597', label: 'Suriname (+597)', iso: 'SR' },
  { value: '992', label: 'Tadjiquistão (+992)', iso: 'TJ' },
  { value: '66', label: 'Tailândia (+66)', iso: 'TH' },
  { value: '886', label: 'Taiwan (+886)', iso: 'TW' },
  { value: '255', label: 'Tanzânia (+255)', iso: 'TZ' },
  { value: '670', label: 'Timor-Leste (+670)', iso: 'TL' },
  { value: '228', label: 'Togo (+228)', iso: 'TG' },
  { value: '676', label: 'Tonga (+676)', iso: 'TO' },
  { value: '1868', label: 'Trinidad e Tobago (+1868)', iso: 'TT' },
  { value: '216', label: 'Tunísia (+216)', iso: 'TN' },
  { value: '993', label: 'Turcomenistão (+993)', iso: 'TM' },
  { value: '90', label: 'Turquia (+90)', iso: 'TR' },
  { value: '688', label: 'Tuvalu (+688)', iso: 'TV' },
  { value: '380', label: 'Ucrânia (+380)', iso: 'UA' },
  { value: '256', label: 'Uganda (+256)', iso: 'UG' },
  { value: '598', label: 'Uruguai (+598)', iso: 'UY' },
  { value: '998', label: 'Uzbequistão (+998)', iso: 'UZ' },
  { value: '678', label: 'Vanuatu (+678)', iso: 'VU' },
  { value: '379', label: 'Vaticano (+379)', iso: 'VA' },
  { value: '58', label: 'Venezuela (+58)', iso: 'VE' },
  { value: '84', label: 'Vietnã (+84)', iso: 'VN' },
  { value: '260', label: 'Zâmbia (+260)', iso: 'ZM' },
  { value: '263', label: 'Zimbábue (+263)', iso: 'ZW' },
  { value: '297', label: 'Aruba (+297)', iso: 'AW' },
  { value: '1441', label: 'Bermudas (+1441)', iso: 'BM' },
  { value: '1345', label: 'Ilhas Cayman (+1345)', iso: 'KY' },
  { value: '1284', label: 'Ilhas Virgens Britânicas (+1284)', iso: 'VG' },
  { value: '1340', label: 'Ilhas Virgens dos EUA (+1340)', iso: 'VI' },
  { value: '1664', label: 'Montserrat (+1664)', iso: 'MS' },
  { value: '1264', label: 'Anguilla (+1264)', iso: 'AI' },
  { value: '590', label: 'São Martinho (+590)', iso: 'MF' },
  { value: '1721', label: 'Sint Maarten (+1721)', iso: 'SX' },
  { value: '590_BL', label: 'Saint Barthélemy (+590)', iso: 'BL' },
  { value: '299', label: 'Groenlândia (+299)', iso: 'GL' },

  { value: '350', label: 'Gibraltar (+350)', iso: 'GI' },
  { value: '298', label: 'Ilhas Faroe (+298)', iso: 'FO' },
  { value: '44_GG', label: 'Guernsey (+44)', iso: 'GG' },
  { value: '44_JE', label: 'Jersey (+44)', iso: 'JE' },
  { value: '44_IM', label: 'Ilha de Man (+44)', iso: 'IM' },

  { value: '852', label: 'Hong Kong (+852)', iso: 'HK' },
  { value: '853', label: 'Macau (+853)', iso: 'MO' },

  { value: '262_YT', label: 'Mayotte (+262)', iso: 'YT' },
  { value: '262_RE', label: 'Reunião (+262)', iso: 'RE' },
  { value: '290', label: 'Santa Helena (+290)', iso: 'SH' },

  { value: '682', label: 'Ilhas Cook (+682)', iso: 'CK' },
  { value: '683', label: 'Niue (+683)', iso: 'NU' },
  { value: '690', label: 'Tokelau (+690)', iso: 'TK' },
  { value: '1684', label: 'Samoa Americana (+1684)', iso: 'AS' },
  { value: '689', label: 'Polinésia Francesa (+689)', iso: 'PF' },
  { value: '687', label: 'Nova Caledônia (+687)', iso: 'NC' },
  { value: '681', label: 'Wallis e Futuna (+681)', iso: 'WF' },
  { value: '692', label: 'Ilhas Marshall (+692)', iso: 'MH' },
];

/** Lookup map: calling code → ISO country code */
export const CODE_TO_ISO: Record<string, string> = Object.fromEntries(
  CALLING_CODES.map((c) => [c.value, c.iso])
);

/** Extract the numeric calling code from a value that may contain a country suffix (e.g. '1_CA' → '1') */
export function extractCallingCode(value: string): string {
  return value.split('_')[0];
}

/**
 * Resolve a raw calling code (from DB, e.g. '1') to a CALLING_CODES value.
 * If the exact value exists, use it. Otherwise, find the first entry whose numeric part matches.
 * When countryIso is provided, prefer the entry matching that ISO code (e.g. '1' + 'US' → '1_US').
 */
export function resolveCallingCode(raw: string, countryIso?: string): string {
  if (CALLING_CODES.some((c) => c.value === raw)) return raw;
  if (countryIso) {
    const byIso = CALLING_CODES.find(
      (c) => extractCallingCode(c.value) === raw && c.iso === countryIso
    );
    if (byIso) return byIso.value;
  }
  const found = CALLING_CODES.find((c) => extractCallingCode(c.value) === raw);
  return found ? found.value : raw;
}
